import React from "react";
import type {FunctionComponent} from "react";
import s from "./ComponentPlayground.module.scss";

export interface IComponentPlaygroundProps {
}

export const ComponentPlayground: FunctionComponent<IComponentPlaygroundProps> = ({}) => {
  return <div className={s.container}>
    HI
  </div>;
}
